import React, { useMemo } from 'react'
import MealForm from './_form'

export default function MealAdd (props) {
  const data = useMemo(() => ({active: false}), [])
  return (
    <MealForm mode='add' data={data} {...props} />
  )
}